<template>
  <div v-redirect-if-no-permission:PLANNING>
    <v-form ref="form">
      <v-container>
        <v-layout wrap>
          <v-flex md2 sm12>
            <!-- <v-label> Shift </v-label> -->
            <choose-date
              clearable
              :label="$t('maps.shiftsMap.filterByDay')"
              v-model="date_filter"
            ></choose-date>
          </v-flex>
          <v-flex md2 sm12>
            <!-- <v-label> {{ hoverText }} </v-label> -->
            <v-select
              item-text="username"
              return-object
              :items="shift_captains"
              v-model="selected_captain"
              @change="getCaptainShifts"
              :label="$t('maps.shiftsMap.captain')"
            ></v-select>
          </v-flex>
          <v-flex md2 sm12>
            <v-select
              :items="event_shifts"
              item-text="name"
              return-object
              v-model="selected_shift"
              :label="$t('maps.shiftsMap.shift')"
              @change="getShiftDetails"
            ></v-select>
          </v-flex>
          <v-flex md2 sm12>
            <v-switch
            v-model="showPaths"
            :label="$t('maps.shiftsMap.paths')"
            @change="switchShowPaths"
            color="blue"
          ></v-switch>
          </v-flex>
          <v-flex md2 sm12>
            <v-switch
            v-model="showLogs"
            :label="$t('maps.shiftsMap.logs')"
            @change="switchShowLogs"
            color="blue"
          ></v-switch>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <div class="card-container">
      <div class="scroller">
        <order-card
        v-for="(booking, index) in bookings"
        :key="index+booking.id"
        :id="parseInt(booking.id)" :data="booking" />
        <logs-table
          :logs="logs"
          :color-coding="actionsColorCoding"
          title-key="status"
          color-coding-key="status"
          datetime-key="created_at"
        />
      </div>
      </div>
      <GmapMap
        :center="center"
        :options="options"
        :zoom="zoom"
        ref="map"
        class="map"
      >
        <!-- <GmapCluster> -->
          <GmapPolyline
            v-if=(showPaths)
            v-for="(booking, index) in bookings"
            @mouseover="showByIndex=`polyline${booking.id}`"
            @mouseout="showByIndex = null"
            @click="showPathInfoWindow(booking)"
            :path="booking.route"
            :key="index+'line'+booking.id"
            :options="pathOptions"
          >
        </GmapPolyline>
          <GmapMarker
          v-if=(showPaths)
          v-for="(booking, index) in bookings"
          :key="index+'pickup'+booking.id"
          :icon="{
            url: require('@/assets/map/pickup-pin.svg'),
            scaledSize: { width: 34, height: 42 },
          }"
          :position="{
            lat: booking.pick_up_location.coordinates[1] + 0.00001 * index,
            lng: booking.pick_up_location.coordinates[0] + 0.00001 * index,
          }"
          @mouseover="showByIndex = `pickup${booking.id}`"
          @mouseout="showByIndex = null"
          :options="markerOptions"
        >
          <gmap-info-window :opened="showByIndex == `pickup${booking.id}`">
            <p style="margin-bottom: 0">{{ $t("maps.shiftsMap.bookingPickupLocation", { id: booking.id }) }}</p>
          </gmap-info-window>
        </GmapMarker>
        <GmapMarker
        v-if=(showPaths)
        v-for="(booking, index) in bookings"
        :key="index+'dropoff'+booking.id"
          :icon="{
            url: require('@/assets/map/dropoff-pin.svg'),
            scaledSize: { width: 34, height: 42 },
          }"
          :position="{
            lat: booking.pull_down_location.coordinates[1] + 0.00001 * index,
            lng: booking.pull_down_location.coordinates[0] + 0.00001 * index,
          }"
          @mouseover="showByIndex = `dropoff${booking.id}`"
          @mouseout="showByIndex = null"
          :options="markerOptions"
        >
          <gmap-info-window :opened="showByIndex == `dropoff${booking.id}`">
            <p style="margin-bottom: 0">{{ $t("maps.shiftsMap.bookingDropoffLocation", { id: booking.id }) }}</p>
          </gmap-info-window>
        </GmapMarker>
          <GmapMarker
            v-if=(showLogs)
            v-for="(log, index) in logs"
            :key="index + 'log' +log.id"
            :icon="{
              url: formSvg(actionsColorCoding[log.status]),
              scaledSize: { width: 50, height: 35 },
            }"
            :position="{
              lat: log.location.coordinates[1] + 0.00001 * index,
              lng: log.location.coordinates[0] + 0.00001 * index,
            }"
            @mouseover="showByIndex = index + 'log'"
            @mouseout="showByIndex = null"
            :options="markerOptions"
          >
            <gmap-info-window :opened="showByIndex == index + 'log'">
              <p style="margin-bottom: 0">
                {{ $t("maps.shiftsMap.statusAt", { status: log.status, time: moment(log.created_at).format("HH[h]mm") }) }}
              </p>
            </gmap-info-window>
          </GmapMarker>
        <!-- </GmapCluster> -->
      </GmapMap>
    </div>
</template>
<script>
import OrderCard from "@/components/dispatching/OrderCard.vue";
import LogsTable from "@/components/dispatching/LogsTable.vue";
import AdditionalInfo from "@/components/dispatching/AdditionalInfo.vue";
import GmapCluster from "vue2-google-maps/dist/components/cluster";
import GmapPolyline from "vue2-google-maps/dist/components/polyline";
import ChooseDate from "@/components/monaco/input/ChooseDate";
// import socketEventsMixin from "@/mixins/socketEventsMixin";
// import GmapMarker from "vue2-google-maps";
import axios from "axios";
import api from "@/constants/api";

const options = {
  mapTypeId: "roadmap",
  disableDefaultUI: true,
  styles: [
    {
      featureType: "administrative",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#a3a4ae",
        },
      ],
    },
    {
      featureType: "landscape",
      elementType: "all",
      stylers: [
        {
          color: "#e6eaf0",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: [
        {
          visibility: "simplified",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "labels.text",
      stylers: [
        {
          visibility: "simplified",
        },
        {
          gamma: "2",
        },
        {
          lightness: "3",
        },
        {
          color: "#778494",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "labels.icon",
      stylers: [
        {
          color: "#788E98",
        },
      ],
    },
    {
      featureType: "poi.attraction",
      elementType: "geometry.fill",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "poi.park",
      elementType: "geometry.fill",
      stylers: [
        {
          visibility: "on",
        },
        {
          color: "#ceead6",
        },
      ],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#39b65c",
        },
      ],
    },
    {
      featureType: "road",
      elementType: "labels",
      stylers: [
        {
          saturation: "0",
        },
        {
          lightness: "35",
        },
        {
          visibility: "simplified",
        },
        {
          gamma: "1",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "all",
      stylers: [
        {
          visibility: "simplified",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#fde293",
        },
      ],
    },
    {
      featureType: "road.arterial",
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off",
        },
        {
          saturation: "-50",
        },
        {
          lightness: "17",
        },
      ],
    },
    {
      featureType: "transit",
      elementType: "all",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "water",
      elementType: "all",
      stylers: [
        {
          color: "#8fbaff",
        },
        {
          visibility: "on",
        },
      ],
    },
  ],
};

function zoomUI(map) {
  // Container

  const zoomUIContainer = document.createElement("div");
  zoomUIContainer.classList = "zoom-container";

  // Zoom in

  const zoomIn = document.createElement("button");
  zoomIn.classList = "zoom-button";
  zoomIn.title = "Click to zoom in";

  const zoomInText = document.createElement("div");
  zoomInText.innerHTML = `+`;
  zoomIn.appendChild(zoomInText);

  zoomUIContainer.append(zoomIn);

  zoomIn.addEventListener("click", () => {
    map.setZoom(map.getZoom() + 1);
  });

  // Zoom out

  const zoomOut = document.createElement("button");
  zoomOut.classList = "zoom-button";
  zoomOut.title = "Click to zoom out";

  const zoomOutText = document.createElement("div");
  zoomOutText.innerHTML = `-`;
  zoomOut.appendChild(zoomOutText);

  zoomUIContainer.append(zoomOut);

  zoomOut.addEventListener("click", () => {
    map.setZoom(map.getZoom() - 1);
  });

  map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(zoomUIContainer);
}

export default {
  name: "MapComponent",
  components: {
    OrderCard,
    GmapCluster,
    GmapPolyline,
    LogsTable,
    AdditionalInfo,
    ChooseDate
  },
  title() {
    return this.$t("maps.shiftsMap.title");
  },
  data() {
    return {
      date_filter: null,
      logs: [],
      bookings:[],
      showPaths:true,
      showLogs:true,
      showByIndex: null,
      actionsColorCoding: {
        IN_STATION: "#293462",
        BUSY: "#1CD6CE",
        FREE: "#1C6758",
        UNAVAILABLE: "#9B1FE8",
        AT_DESTINATION: "#E10015",
      },
      markerOptions: {
        zIndex: 1000, // Set a high z-index value
      },
      selected_shift: null,
      selected_captain: null,
      shift_captains: [],
      event_shifts: [],
      center: { lat: 43.738359, lng: 7.426723 },
      zoom: 17, // set initial zoom level of map
      paths: [], // array of paths to draw
      points: [], // array of points to draw
      options: options,
      pathOptions: {
        strokeColor: "#000000",
        strokeOpacity: 1.0,
        strokeWeight: 4,
        clickable: true,
      },
      hoverText: null,
      hoverPathIndex: null,
      hoverPosition: null,
      selectedPathIndex: null,
    };
  },
  methods: {
    switchShowPaths(value){
      this.showPaths = value;
    },
    switchShowLogs(value){
      this.showLogs = value;
      // console.log("showLogs new value");
      // console.log(this.showLogs);
    },
    formSvg(color) {
      return (
        "data:image/svg+xml;utf8," +
        encodeURIComponent(`
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="33.625" height="41.385" viewBox="0 0 33.625 41.385">
        <defs>
          <clipPath id="clip-path">
            <rect id="Rectangle_3619" data-name="Rectangle 3619" width="33.625" height="41.385" transform="translate(163 565)" fill="none"/>
          </clipPath>
        </defs>
        <g id="Mask_Group_6" data-name="Mask Group 6" transform="translate(-163 -565)" clip-path="url(#clip-path)">
          <g id="Monaco_Pin_Active" data-name="Monaco Pin Active" transform="translate(163.259 565)">
            <g id="Group_322" data-name="Group 322" transform="translate(6.622 22.284)">
              <path id="Path_374" data-name="Path 374" d="M42.018,34.462l-9.932,19.1-9.932-19.1a17.086,17.086,0,0,0,19.865,0Z" transform="translate(-22.154 -34.462)" fill="${color}"/>
            </g>
            <g id="Group_323" data-name="Group 323" transform="translate(0)">
              <circle id="Ellipse_3825" data-name="Ellipse 3825" cx="16" cy="16" r="16" transform="translate(0.741)" fill="${color}"/>
              <path id="Path_376" data-name="Path 376" d="M23.081,19.3a9.705,9.705,0,0,1-5.418-1.658l-.123-.118a8.642,8.642,0,0,1-3.694-7.1,9.242,9.242,0,0,1,18.47,0,8.642,8.642,0,0,1-3.694,7.1l-.123.118A9.705,9.705,0,0,1,23.081,19.3Z" transform="translate(-6.527 5.499)" fill="#fff"/>
            </g>
          </g>
        </g>
      </svg>`)
      );
    },
    onMapClick(event) {
      // add a point to the points array when the map is clicked
      this.points.push({
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      });
    },
    onPathMouseover(index) {
      this.hoverPathIndex = index;
      this.hoverPosition = this.paths[index][0];
      // Set the hoverText variable to the text you want to display
      this.hoverText = this.$t("maps.shiftsMap.thisIsPath", { index });
    },
    onPathMouseout() {
      this.hoverPathIndex = null;
      this.hoverPosition = null;
      this.hoverText = null;
    },
    getEventShifts() {
      axios
        .get(`plan/${$route.params.id}/shifts`)
        .then((res) => {
          //
        })
        .catch(() => {});
    },
    getShiftDrivers(shift) {
      var shift_id = shift.id;
      this.shift_captains = [
        {
          name: "Ahmad",
          id: 1,
        },
        {
          name: "Samer",
          id: 1,
        },
      ];
    },
    getShiftDetails() {
      const params = new URLSearchParams();
      params.append("captain_id", this.selected_captain.captain_id);
      params.append("shift_date", this.date_filter);
      params.append("shift_id", this.selected_shift.id);
      this.axios
        .get(
          "shifts/details",
          { params },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            provider: "users",
          }
        )
        .then((res) => {
          var checkLogs = res.data.data.checkLogs;
          var bookings = res.data.data.bookings;
          this.logs = checkLogs;
          this.bookings = bookings;
          // bookings.forEach((booking) => {
          //   booking.route.forEach((route) => {
          //     let obj = {};
          //     obj["lat"] = parseFloat(route.lat);
          //     obj["lng"] = parseFloat(route.lng);
          //     this.paths.booking['id'].push(obj);
          //   });
          // });
          // console.log("CaptainData");
          // console.log(res.data.data);
        })
        .catch((err) => {
          console.log("err");
          console.log(err);
        });
    },
    getCaptainShifts(captain){
      const params =new URLSearchParams();
      params.append("shift_date", this.date_filter);
      params.append("captain_id", captain.captain_id);
      this.axios
        .get(
          "shifts/captain",
          { params },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            provider: "users",
          }
        )
        .then((res) => {
          this.event_shifts=res.data.data;
          this.event_shifts = res.data.data.map(shift => ({ ...shift, name: `${shift.from} - ${shift.to}` }));
        })
        .catch((err) => {
          console.log("err");
          console.log(err);
        });
    },
    showPathInfoWindow(booking){
      this.$dialova({
          title: this.$t("maps.shiftsMap.bookingPath", { id: booking.id }),
          paragraph: `${this.$t("maps.shiftsMap.statusLine", { status: booking.status })}<br>
          ${this.$t("maps.shiftsMap.pickupLocationLine", { location: booking.landmark_pickup })}<br>
          ${this.$t("maps.shiftsMap.dropoffLocationLine", { location: booking.landmark_dropoff })}<br>
          ${this.$t("maps.shiftsMap.createdAtLine", { date: booking.created_at })}<br>
          ${moment(booking.datetime).format("HH[h]m - DD[/]MM[/]YYYY")}`,
          hideCancel: true,
        })
    },
    getShiftCaptains(){
      const params =new URLSearchParams();
      params.append("shift_date", this.date_filter);
      this.axios
        .get(
          "shifts/shiftCaptains",
          { params },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            provider: "users",
          }
        )
        .then((res) => {
          this.shift_captains=res.data.data;
        })
        .catch((err) => {
          console.log("err");
          console.log(err);
        });
    },
  },
  mounted() {
    //
  },
  computed: {
  //   shiftDetails() {
  //   return this.event_shifts.map(shift => ({ name: `${shift.from} - ${shift.to}` }));
  // }
  },
  watch: {
    date_filter() {
      this.selected_captain = "";
      this.selected_shift = "";
      this.shift_captains = null;
      this.event_shifts = null;
      this.bookings = null;
      this.logs = null;
      this.getShiftCaptains();
    },
    showByIndex(newIndex) {
      // console.log("index changed");
      // console.log(newIndex);
    },
  },
};
</script>

<style lang="scss">
.popup {
  background-color: white;
  padding: 5px;
  border: 1px solid black;
}
.hover-text {
  position: absolute;
  z-index: 100;
  background-color: white;
  padding: 5px;
  border: 1px solid black;
}
.card-container {
  width: 400px;
  height: auto;
  position: absolute;
  z-index: 4;
  bottom: 0px;
  left: 55px;
  max-height: calc(100vh - 64px);
  padding-top: 22px;
  padding-bottom: 22px;
  overflow-y: overlay;

  &::-webkit-scrollbar {
    width: 0;
  }

  .scroller {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    flex-direction: column;
    gap: 12px;

    div {
      flex-grow: 0;
      flex-shrink: 1;
    }
  }
}

.map {
  height: calc(100vh - 64px);
  outline: none;
}

.zoom-container {
  width: max-content;
  height: max-content;
  bottom: 20px !important;
  right: 55px !important;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.zoom-button {
  height: 48px;
  width: 48px;
  background-color: #fff;
  border: 1px solid #c1c5d8;
  color: #222629;
  font-size: 18px;
  border-radius: 10px;
  outline: none;
}

.geofence-logs {
  color: #222629;

  tr,
  td,
  th {
    padding: 2px;
  }

  tr {
    td:first-child {
      padding-left: 0;
    }
  }
}
</style>
